import React, { useEffect, useRef } from "react";
import { Form, FormGroup } from "react-bootstrap";
import { useFormikContext } from "formik";
import { useDispatch, useSelector } from "react-redux";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import FormikSelectField from "../../../../shared/components/FormikSelectField";
import FormTextField from "../../../../shared/components/FormTextField";
import { loadMessageTemplateDropdown } from "../redux/Actions";

const TicketSolution = ({ values, setFieldValue, solution }) => {
  const dispatch = useDispatch();
  const { errors } = useFormikContext();
  const { templates } = useSelector((state) => state.messageTemplateDropdown);
  const quillRef = useRef(null);

  useEffect(() => {
    dispatch(loadMessageTemplateDropdown("solution"));
  }, [dispatch]);

  const modules = {
    toolbar: [
      [{ 'header': '1' }, { 'header': '2' }, { 'font': [] }],
      [{ 'list': 'ordered' }, { 'list': 'bullet' }],
      ['bold', 'italic', 'underline', 'strike'],
      ['link'],
    ],
  };

  const handlePaste = (e) => {
    const clipboard = e.clipboardData;
    if (!clipboard) return;

    const items = clipboard.items;
    for (let i = 0; i < items.length; i++) {
      const item = items[i];

      if (item.type.indexOf("image") !== -1) {
        const file = item.getAsFile();
        const reader = new FileReader();

        reader.onload = () => {
          const base64 = reader.result;
          const quill = quillRef.current.getEditor();
          const range = quill.getSelection(true);
          quill.insertEmbed(range.index, "image", base64);
          quill.setSelection(range.index + 1);
        };

        reader.readAsDataURL(file);
        e.preventDefault();
      }
    }
  };

  const resolutionTypes = [
    { label: "Fixed", value: "fixed" },
    { label: "Workaround", value: "workaround" },
    { label: "Cannot Reproduce", value: "cannot_reproduce" },
    { label: "Duplicate", value: "duplicate" },
    { label: "Won’t Fix", value: "wont_fix" },
    { label: "User Error", value: "user_error" },
    { label: "Configuration", value: "configuration" },
    { label: "Other", value: "other" },
  ];

  const adminGroup = values?.adminGroup;

  return (
    <div>
      <Form>

        {/* Resolution Type Dropdown */}
        <FormGroup className="mb-3">
          <label className="form-label"><strong>Resolution Type</strong></label>

          <FormikSelectField
            name="solution.resolution_type"
            value={values.solution?.resolution_type || "fixed"}
            onChange={(name, value) => setFieldValue(name, value)}
            placeholder="Select resolution type"
          >
            {resolutionTypes.map((rt) => (
              <option key={rt.value} value={rt.value}>
                {rt.label}
              </option>
            ))}
          </FormikSelectField>
        </FormGroup>

        {/* Solution Template Dropdown */}
        <FormGroup className="mb-3">
          <div style={{ width: "260px", float: "right" }}>
            <Form.Select
              size="sm"
              onChange={(e) => {
                const value = e.target.value;

                if (!value) {
                  return;
                }

                const selectedId = Number(value);
                const selectedTemplate = templates?.find((t) => t.id === selectedId);

                if (selectedTemplate) {
                  // Set the HTML content directly to the rich text editor
                  setFieldValue("solution.solution_text", selectedTemplate.template_message);
                }
              }}
            >
              <option value="">Select Solution Template</option>
              {templates?.map((template) => (
                <option key={template.id} value={template.id}>
                  {template.template_name}
                </option>
              ))}
            </Form.Select>
          </div>
          <div style={{ clear: "right" }} />
        </FormGroup>

        {/* Solution Rich Text Editor */}
        <FormGroup controlId="solution.solution_text">
          <Form.Label><strong>Solution</strong></Form.Label>
          <div className="ticket-quill-wrapper">
            <ReactQuill
              ref={quillRef}
              value={values.solution?.solution_text || ""}
              onChange={(val) => setFieldValue("solution.solution_text", val)}
              modules={modules}
              onPaste={handlePaste}
              placeholder="Enter the solution..."
            />
          </div>
          {errors?.solution?.solution_text && (
            <div className="text-danger small mt-1">
              {errors.solution.solution_text}
            </div>
          )}
        </FormGroup>

        {/* COST only for adminGroup = 14 - Facilities */}
        {adminGroup === 14 && (
          <FormGroup controlId="solution.cost">
            <Form.Label><strong>Cost</strong></Form.Label>
            <Form.Control
              type="text"
              placeholder="Enter cost details"
              value={values.solution?.cost || ""}
              onChange={(e) => setFieldValue("solution.cost", e.target.value)}
            />
          </FormGroup>
        )}

      </Form>
    </div>
  );
};

export default TicketSolution;
